import commonStyle from "./common.module.css"
import selectStyle from "./select.module.css"


export default function Select(props) {

    const label = props['label']
    const name = props['name']
    const option = props['option']
    const required = props['required']
    const error = props['error']

    return (
        <div className={commonStyle['wrap']}>
            <input
                type="text"
                category="field"
                name={name}
                required={required === true ? true : false}
                style={{
                    display: "none"
                }}
                readOnly={true}
                error={error}
            ></input>

            {label &&
                <label
                    className={required === true ? commonStyle['required'] : null}
                >{label}</label>
            }

            <div className={commonStyle['field']}>
                <select
                    name={name}
                    className={selectStyle['select']}
                    onChange={(e) => {
                        document.querySelector(`[name="${name}"][category="field"]`).value = e.currentTarget.value
                    }}
                >
                    {option
                    .map((value, index) => {
                        return(
                            <option
                                key={index}
                                value={value['value']}
                            >{value['name']}</option>
                        )
                    })}
                </select>
            </div>

            {error &&
                <span
                    className={commonStyle['error']}
                >{error}</span>
            }
        </div>
    );
}